import React from 'react';

const NewContact = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 24 24">
    <path fill="#3FB0E8" fillRule="evenodd" d="M19.557 14.344l.07.029.13.17-.001 3.505 3.614.03.13.17-.03 1.418-.17.129-3.545-.002-.027 3.578-.171.129-1.431-.029-.13-.17-.002-3.509-3.61-.026-.131-.17.029-1.418.17-.13h3.543l.03-3.575.17-.13h1.362zM11.927.5c3.633 0 6.59 2.956 6.59 6.588 0 3.466-2.697 6.33-6.12 6.572l-.236.012-.5.008-.267.011c-4.847.263-8.762 4.093-9.159 8.903l-.018.268-.011.27-.002.127-.099.098H.599L.5 23.256l.003-.193c.085-2.929 1.266-5.666 3.343-7.743 1.044-1.045 2.263-1.87 3.603-2.44l.369-.149.453-.164-.073-.05-.208-.15c-1.667-1.245-2.652-3.193-2.652-5.279C5.338 3.456 8.294.5 11.928.5zm0 1.704c-2.693 0-4.884 2.191-4.884 4.884 0 2.694 2.19 4.885 4.884 4.885 2.694 0 4.885-2.191 4.885-4.885 0-2.693-2.191-4.884-4.885-4.884z"/>
  </svg>
);

export default NewContact;
